/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from "react";
import Tabs from "@fdn/tabs";
import vars from "Consts/vars";
import TabAll from "Components/search/search_result/tab_all/tabAll";
import TabProduct from "Components/search/search_result/tab_product/tabProduct";
import TabService from "Components/search/search_result/tab_service/tabService";
import TabBrand from "Components/search/search_result/tab_brand/tabBrand";
import TabArticle from "Components/search/search_result/tab_article/tabArticle";
import TabUser from "Components/search/search_result/tab_user/tabUser";
import SkeletonTabAll from "Components/skeleton/search/tab_all/skeletonTabAll";
import SkeletonTabProduct from "Components/skeleton/search/tab_product/skeletonTabProduct";
import SkeletonTabBrand from "Components/skeleton/search/tab_brand/skeletonTabBrand";
import SkeletonTabArticle from "Components/skeleton/search/tab_article/skeletonTabArticle";
import SkeletonTabUser from "Components/skeleton/search/tab_user/skeletonTabUser";
import { useRouter } from "next/router";
import { objectToQueryString } from "helpers/queryString";

const Mobile = (props) => {

	const prop = props;
	const router = useRouter();

	const [activeTab, setActiveTab] = useState(prop?.query?.tab === "services" ? "Salon & Clinic" : prop?.query?.tab || "all");

	const onClickTab = (tabs) => {

		const queryParams = objectToQueryString({
			q: prop.query.q,
			tab: tabs === "Salon & Clinic" ? "services" : tabs,
			type: tabs === "brands" ? "product" : "",
		});
		router.push({
			pathname: "/search",
		}, `/search?${queryParams}`, { shallow: true });

		setActiveTab(tabs);

	};

	useEffect(() => {

		document.getElementById(prop?.query?.tab || "").scrollIntoView();

	}, [prop.query.tab]);

	return (
		<div className="container-search-result">
			<p className="container-search-result__keyword">
				Search result for “
				{prop.keyword}
				”
			</p>
			<Tabs
				on_click={onClickTab}
				tab_active={activeTab}
				color_active="#DB284E"
				color_inactive="#919EAB"
				font_family="Roboto"
			>
				<div className="container-search-result__section-all-tab" id="all" label={vars.SEARCH_TAB.ALL}>
					{prop.query.tab === vars.SEARCH_TAB.ALL
						&& prop.isTabAllLoading ? <SkeletonTabAll isMobile={prop.isMobile} />
						: (
							<TabAll
								isMobile={prop.isMobile}
								dataArticle={prop.allResult.articles}
								dataBrand={prop.allResult.brands}
								dataService={prop.allResult.services}
								dataProduct={prop.allResult.products}
								dataUser={prop.allResult.users}
								defaultPicture={vars.BROKEN_IMAGE.square}
								defaultPictureProfile={prop.defaultPictureProfile}
								limitDataBrand={prop.limitDataBrand}
								limitDataProduct={prop.limitDataProduct}
								limitDataService={prop.limitDataService}
								limitDataArticle={prop.limitDataArticle}
								limitDataUser={prop.limitDataUser}
								keyword={prop.keyword}
								query={prop.query}
								isResultLoading={prop.isResultLoading}
								setResultLoading={prop.setResultLoading}
								onClickTab={onClickTab}
							/>
						)}
				</div>

				{/* tab Product */}
				<div className="container-search-result__section-all-tab" id="products" label={vars.SEARCH_TAB.PRODUCT}>
					{prop.query.tab === vars.SEARCH_TAB.PRODUCT
						&& prop.isTabProductLoading ? <SkeletonTabProduct isMobile={prop.isMobile} />
						: <TabProduct isMobile={prop.isMobile} {...prop} activeTab={activeTab} />}
				</div>

				{/* tab clinic */}
				<div className="container-search-result__section-all-tab" id="services" label="Salon & Clinic">
					{prop.query.tab === vars.SEARCH_TAB.SERVICE
						&& prop.isTabServiceLoading ? <SkeletonTabProduct isMobile={prop.isMobile} />
						: <TabService isMobile={prop.isMobile} {...prop} activeTab={activeTab} />}
				</div>

				<div className="container-search-result__section-all-tab" id="brands" label={vars.SEARCH_TAB.BRAND}>
					{prop.query.tab === vars.SEARCH_TAB.BRAND
						&& (prop.isTabBrandLoading || prop.isTabBrandServiceLoading)
						? <SkeletonTabBrand isMobile={prop.isMobile} />
						: <TabBrand isMobile={prop.isMobile} {...prop} activeTab={activeTab} />}
				</div>
				<div className="container-search-result__section-all-tab" id="articles" label={vars.SEARCH_TAB.ARTICLE}>
					{prop.query.tab === vars.SEARCH_TAB.ARTICLE
						&& prop.isTabArticleLoading ? <SkeletonTabArticle isMobile={prop.isMobile} />
						: <TabArticle isMobile={prop.isMobile} {...prop} activeTab={activeTab} />}
				</div>
				<div className="container-search-result__section-all-tab" id="users" label={vars.SEARCH_TAB.USER}>
					{prop.query.tab === vars.SEARCH_TAB.USER
						&& prop.isTabUserLoading ? <SkeletonTabUser isMobile={prop.isMobile} />
						: <TabUser isMobile={prop.isMobile} {...prop} activeTab={activeTab} />}
				</div>
			</Tabs>

			<style>
				{`
					.container-search-result .fdn-tabs-container .tabs-list ul{
						display: flex;
						justify-content: space-between;
					}
					.container-search-result .fdn-tabs-container .tabs-list ul li span{
						font-family: 'Creato Display';
						font-style: normal;
						font-weight: 400;
						font-size: 14px;
						line-height: 22px;
						text-transform: capitalize;
					}
					.container-search-result .fdn-tabs-container .tabs-list ul li::before {
						background: #DB284E;
					}
					.container-search-result .fdn-tabs-container .tabs-list {
						border-bottom: 1px solid #DFE3E8;
						display: flex;
						overflow-y: hidden;
						overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.container-search-result .fdn-tabs-container .tabs-list::-webkit-scrollbar {
							display: none;
						}
				`}
			</style>
			<style jsx>
				{`
						.container-search-result{
							padding: 24px;
							padding-top: 10px;
							max-width: 480px;
							margin: auto;
						}
						.container-search-result__keyword{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
							line-height: 22px;
							color: #13161A;
							margin-top:13px;
							margin-bottom: 16px;
							text-overflow: ellipsis;
							-webkit-line-clamp: 1;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							overflow: hidden;
						}
						.container-search-result__section-title{
							display: flex;
							margin-top: 36px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.container-search-result__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.container-search-result__section-brand{
							display: flex;
							gap: 20px;
							margin-bottom: 12px;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.container-search-result__section-brand::-webkit-scrollbar {
							display: none;
						}
						.container-search-result__section-image-brand{
							height: 50px;
							width: 100px;
							padding: 5px 10px;
						}
						.container-search-result__image-brand{
							width: -webkit-fill-available;
							height: -webkit-fill-available;
						}
						.container-search-result__product{
							display: flex;
							column-gap: 12px;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.container-search-result__product::-webkit-scrollbar {
							display: none;
						}

						.container-search-result__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
						}
						.container-search-result__users{
							display: flex;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.container-search-result__users::-webkit-scrollbar {
							display: none;
						}
						.container-search-result__talk-groups{
						    display: flex;
							gap: 200px;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.container-search-result__talk-groups::-webkit-scrollbar {
							display: none;
						}
					`}
			</style>
		</div>

	);

};

export default Mobile;
